import { useRef, useState } from 'react';
import {
  ButtonDiv,
  ActivedButtonContainer,
  ActiveMenu,
  MenuNone,
  MenuText,
  MenuCheck,
  MenuUnmarked,
  MenuOption,
  FilterClient,
  FilterModalTitle,
  FilterModalInput,
  FilterModalButtons,
  FilterRenderControler,
  FilterActivesText,
  FilterActivesData,
  FilterActivesClose,
  FilterActives1,
  FilterActives2,
  FilterActives3,
} from './styles';
import Button from '../general/Button';
import { useOutsideDrop } from '../../hooks/useOutsideDrop';
import Input from '../general/Input';
import ArrowRightMTask from '../../assets/TaskModalIcons/ArrowRightMTask';

import Filter from '../../assets/icons/Filter';
import Check from '../../assets/icons/Check';
import Close from '../../assets/icons/Close';

export function FilterOptions({
  open,
  setOpen,
  type,
  setType,
  titleSearch,
  clientSearch,
  setClientSearch,
  setUrlParams = null,
  fetchFlows,
}) {
  const containerRef = useRef(null);
  useOutsideDrop(containerRef, () => {
    setOpen(false);
  });
  const [clientOpen, setClientOpen] = useState(false);


  return (
    <>
      {!open ? (
        <ButtonDiv>
          <Button
            Icon={() => <Filter />}
            onClick={(e) => {
              setOpen(!open);
              e.stopPropagation();
            }}
            content="Filtros"
          />
        </ButtonDiv>
      ) : (
        <ActivedButtonContainer ref={containerRef}>
          <Button
            colorText="#7e858f"
            Icon={() => <Filter />}
            onClick={() => {
              setOpen(!open);
            }}
            content="Filtros"
            greenBase
          />
          <ActiveMenu>
            <MenuNone
              onClick={() => {
                if (!(!type.alpha && !type.creation))
                  setType({ ...type, alpha: false, creation: false });
              }}
            >
              <MenuText>Nenhum</MenuText>
              <MenuCheck>
                {!type.alpha && !type.creation ? (
                  <Check height={'1rem'} />
                ) : (
                  <MenuUnmarked />
                )}
              </MenuCheck>
            </MenuNone>
            <MenuOption
              onClick={() => {
                if (!(type.alpha && !type.creation))
                  setType({ ...type, alpha: true, creation: false });
              }}
            >
              <MenuText>Ordem Alfabética</MenuText>
              <MenuCheck>
                {type.alpha ? <Check height={'1rem'} /> : <MenuUnmarked />}
              </MenuCheck>
            </MenuOption>
            <MenuOption
              onClick={() => {
                if (!(!type.alpha && type.creation))
                  setType({ ...type, alpha: false, creation: true });
              }}
            >
              <MenuText>Data de Início</MenuText>
              <MenuCheck>
                {type.creation ? <Check height={'1rem'} /> : <MenuUnmarked />}
              </MenuCheck>
            </MenuOption>
            <MenuOption
              onClick={() => {
                setClientOpen(true);
              }}
            >
              <MenuText>Filtrar por Cliente</MenuText>
              <ArrowRightMTask />
            </MenuOption>
          </ActiveMenu>
          {clientOpen ? (
            <FilterClient>
              <FilterModalTitle>Filtrar por Cliente:</FilterModalTitle>
              <FilterModalInput>
                <Input
                  placeholder={'Cliente ...'}
                  value={clientSearch}
                  setValue={(e) => {
                    setClientSearch(e);
                  }}
                  height="2.15rem"
                />
              </FilterModalInput>
              <FilterModalButtons>
                <Button
                  content={'Cancelar'}
                  width={'4.85rem'}
                  outline
                  onClick={() => {
                    setClientOpen(false);
                    setClientSearch('');
                  }}
                />
                <Button
                  content={'Aplicar filtro'}
                  width={'6.05rem'}
                  onClick={() => {
                    //Requisição
                    setType({ ...type, client: clientSearch });

                    setClientOpen(false);
                  }}
                />
              </FilterModalButtons>
            </FilterClient>
          ) : null}
        </ActivedButtonContainer>
      )}
      <FilterRenderControler>
        {!(!type.creation && !type.alpha) ? ( //! none
          <FilterActives1>
            <FilterActivesText>Ordenação: </FilterActivesText>
            <FilterActivesData>
              {type.creation
                ? 'Data de Início'
                : type.alpha
                ? 'Ordem Alfabética'
                : null}
            </FilterActivesData>
            <FilterActivesClose>
              <Close
                onClick={() => {
                  setType({ ...type, creation: false, alpha: false });
                }}
              />
            </FilterActivesClose>
          </FilterActives1>
        ) : null}
        {type.client !== '' ? (
          <FilterActives2 Filter1Open={type.client}>
            <FilterActivesText>Cliente: </FilterActivesText>
            <FilterActivesData>{type.client}</FilterActivesData>
            <FilterActivesClose>
              <Close
                onClick={() => {
                  setType({ ...type, client: '' });
                }}
              />
            </FilterActivesClose>
          </FilterActives2>
        ) : null}
        {type.title !== '' ? (
          <FilterActives3
            Filter1Open={type.creation || type.alpha}
            Filter2Open={type.client}
          >
            <FilterActivesText>Fluxo: </FilterActivesText>
            <FilterActivesData>{type.title}</FilterActivesData>
            <FilterActivesClose>
              <Close onClick={() => setType({ ...type, title: '' })} />
            </FilterActivesClose>
          </FilterActives3>
        ) : null}
      </FilterRenderControler>
    </>
  );
}
